// Componente que genera la Cabecera con el logo y el título de la encuesta
// ============
import React from 'react';
// ============
import classes from './Cabecera.css';

export default function Cabecera({ tituloEncuesta, subtitulo }) {
  // Return del componente
  return (
    <div className={classes.head}>
      <img className={classes.logo} src="/img/logoGaussEiffelJalisco.png" alt="Gauss Sistemas | Eiffel + Jalisco" />
      {tituloEncuesta && (
        <div>
          <h1>{tituloEncuesta}</h1>
          {subtitulo && <div className={classes.ot}>{subtitulo}</div>}
        </div>
      )}
    </div>
  );
}
